import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { useIsDesktopDimension } from '@beef/ui-kit';
import { Modal } from "../../../Modal";
import { ActionBar } from "../ActionBar";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var MenuModalLayout = function MenuModalLayout(_ref) {
  var isOpen = _ref.isOpen,
    toggleMenuModal = _ref.toggleMenuModal,
    toggleStepModalOnSearch = _ref.toggleStepModalOnSearch,
    isSearchStep = _ref.isSearchStep,
    children = _ref.children;
  var isDesktop = useIsDesktopDimension();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    firstRender = _useState2[0],
    setFirstRender = _useState2[1];
  useEffect(function () {
    setFirstRender(true);
  }, []);
  return /*#__PURE__*/React.createElement(Modal, {
    actionBarNode: /*#__PURE__*/React.createElement(ActionBar, {
      isSearchStep: isSearchStep,
      onCloseButtonClick: toggleMenuModal,
      onSearchButtonClick: toggleStepModalOnSearch
    }),
    closeOptions: {
      button: false,
      overlay: true,
      escape: true
    },
    disableOutsideClickHandler: !isDesktop,
    fullWidthContent: isDesktop,
    isOpen: isOpen,
    onClose: function onClose() {
      return toggleMenuModal();
    },
    portalClassName: cn('menu-portal'),
    style: {
      zIndex: 555
    },
    theme: "light",
    "data-t-id": "components-MenuModalLayout"
  }, firstRender && children);
};